import type { Router } from 'vue-router'

let vueRouter: Router

export function setVueRouter(router: Router): void {
  vueRouter = router
}

export function getVueRouter(): Router {
  return vueRouter
}
